module.exports = __webpack_public_path__ + "static/media/_nato.489305b2.png";